import { Outlet } from "react-router-dom";
import CounterpartyForm from "./CounterpartyForm";
import CounterpartyList from "./CounterpartyList";

export const adminCounterpartiesRoutes = [
  {
    path: "counterparties",
    element: Outlet,
    children: [
      { path: "", element: CounterpartyList },
      { path: "list", element: CounterpartyList },
      { path: "add", element: CounterpartyForm },
      { path: "edit/:id", element: CounterpartyForm },
    ],
  },
];
